import { Component, ContentChildren, Input, QueryList } from '@angular/core';

import { ListItemDirective } from '~/core/directives/list-item.directive';

@Component({
  selector: 'app-organizer-shared-action-list',
  templateUrl: './action-list.component.html',
})
export class OrganizerSharedActionListComponent {
  @ContentChildren(ListItemDirective)
  public actions: QueryList<ListItemDirective>;

  @Input() public title?: string;
}
